import React from "react"
import {useTheme} from "@mui/material"
import {
    SEARCH_CLEAR_PREVIOUS_SEARCH_DATA_GA,
    SEARCH_DATA_GA,
    SEARCH_PREVIOUS_SEARCH_DATA_GA,
} from "../../../../../../config/constants"
import {HeaderWrapper} from "../../../components"
import GridContent from "../../../components/GridContent"
import RecentSearchesContent from "../../../components/RecentSearchesContent"
import RecentSearches from "../../../../../../components/RecentSearches"
import {
    Container,
    StyledGridWrapper,
    ContentContainer,
    ClearButtonDesktopWrapper,
    StyledClearButtonDesktop,
    HeaderContainer,
    StyledClearButton,
} from "./components"
import {StyledTypography} from "../../components"
import {useMediaQuery} from "../../../../../../hooks/useMediaQuery"

type HeaderProps = {
    clear: () => void
    text: any
    showClearAll: boolean
}

const clrBtnTestid = "header-recent-searches-clear-button"

const Header = ({clear, text, showClearAll}: HeaderProps) => {
    const {mobileHeader, desktopHeader, clearAllButton} = text
    const theme = useTheme()
    const isMedUp = useMediaQuery(theme.breakpoints.up("md"))

    return (
        <HeaderContainer className="recents-header" data-testid="recents-header">
            <HeaderWrapper>
                <StyledTypography variant="subtitle2">{isMedUp ? desktopHeader : mobileHeader}</StyledTypography>
                {showClearAll && !isMedUp && (
                    <StyledClearButton
                        data-testid={`${clrBtnTestid}-drawer`}
                        onClick={clear}
                        data-ga-v1={SEARCH_DATA_GA}
                        data-ga-v2={SEARCH_CLEAR_PREVIOUS_SEARCH_DATA_GA}
                        data-ga-v3={SEARCH_PREVIOUS_SEARCH_DATA_GA}
                    >
                        {clearAllButton}
                    </StyledClearButton>
                )}
            </HeaderWrapper>
        </HeaderContainer>
    )
}

export type RecentSearchesProps = {
    clear: () => void
    text: any
    showClearAll: boolean
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

const Content = (props: RecentSearchesProps) => {
    return (
        <Container data-testid="header-enrich-recent-searches">
            <GridContent>
                <ContentContainer
                    isNoResults
                    isRecentSearches
                    data-testid="contentcontainer"
                    showSelectionHighlight={false}
                >
                    <Header {...props} />
                    <StyledGridWrapper isRecentSearches showSelectionHighlight={false}>
                        <RecentSearchesContent testid="recents-body">
                            <RecentSearches />
                        </RecentSearchesContent>
                    </StyledGridWrapper>
                </ContentContainer>
                <ClearButtonDesktopWrapper>
                    {props.showClearAll && (
                        <StyledClearButtonDesktop
                            data-testid={clrBtnTestid}
                            onClick={props.clear}
                            data-ga-v1={SEARCH_DATA_GA}
                            data-ga-v2={SEARCH_CLEAR_PREVIOUS_SEARCH_DATA_GA}
                            data-ga-v3={SEARCH_PREVIOUS_SEARCH_DATA_GA}
                        >
                            {props.text.clearAllButton}
                        </StyledClearButtonDesktop>
                    )}
                </ClearButtonDesktopWrapper>
            </GridContent>
        </Container>
    )
}

const Club25RecentSearches = (props: RecentSearchesProps) => {
    return <Content {...props} />
}

export default Club25RecentSearches
